<template>
  <div>
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-input
            v-model="queryParam.keyWord"
            placeholder="搜索关键字"
          >
            <a-select
              slot="addonBefore"
              v-model="queryParam.searchType"
              placeholder="搜索类型"
              style="width: 120px"
            >
              <a-select-option
                :value="item.id"
                :key="item.id"
                v-for="item in dict.searchTypeDict"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <a-form-item class="mr-20">
          <a-select
            v-model="queryParam.status"
            allowClear
            placeholder="状态"
            style="width: 180px"
          >
            <a-select-option
              v-for="item in dict.statusDict"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handlePrint"
        >打印云码</a-button>
        <a-button
          type="primary"
          class="mr-20"
          @click="handleExport"
        >导出</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <span
          slot="qrcode_pic"
          slot-scope="text"
          v-if="text"
        >
          <img
            :src="text"
            @click="handlePreviewPic(text)"
            style="width:64px;height:64px"
          />
        </span>
        <span
          slot="relation_type"
          slot-scope="text"
        >
          {{ text | valInDict(dict.relationTypeDict) }}
        </span>
        <span
          slot="status"
          slot-scope="text"
        >
          <a-tag :color="text |statusTagFilter2">
            {{ text | valInDict(dict.statusDict) }}
          </a-tag>
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
    <!-- 查看大图 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
      :width="500"
    >
      <img
        alt="example"
        style="width:100%; margin-top:30px"
        :src="previewImage"
      />
    </a-modal>
  </div>
</template>

<script>
import HeadInfo from '@/components/tools/HeadInfo'
import { TcgTable } from '@/components'
import { getCodeList, getCoderPre } from '@/api/print'
import { downloadFile } from '@/utils'

const defaultQueryParam = {
  searchType: 'security_code'
}

export default {
  name: 'SecurityCodeDetail',
  components: { HeadInfo, TcgTable },
  data() {
    return {
      queryParam: Object.assign({}, defaultQueryParam),
      // 字典
      dict: {
        searchTypeDict: [{ id: 'security_code', name: '云码' }, { id: 'sc_id', name: '顺序号' }],
        statusDict: [],
        relationTypeDict: [{ id: 'PAGE', name: '页面' }, { id: 'GOODS', name: '商品' }]
      },
      // 预览图片
      previewVisible: false,
      previewImage: '',
      columns: [
        {
          title: '云码',
          dataIndex: 'security_code'
        },
        {
          title: '顺序号',
          dataIndex: 'sc_id',
          width: '80px'
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name',
          width: '80px'
        },
        {
          title: '二维码',
          dataIndex: 'qrcode_pic',
          width: '100px',
          scopedSlots: { customRender: 'qrcode_pic' }
        },
        {
          title: '查询次数',
          width: '90px',
          dataIndex: 'query_count'
        },
        {
          title: '跳转类型',
          width: '90px',
          dataIndex: 'relation_type',
          scopedSlots: { customRender: 'relation_type' }
        },
        {
          title: '页面/商品名称',
          dataIndex: 'relation_name',
          width: '140px'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '80px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '打印时间',
          dataIndex: 'last_print_time'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        const { relation_id, relation_type } = this.$route.query
        return getCodeList(Object.assign(parameter, this.queryParam, { relation_id, relation_type })).then((res) => {
          return res
        })
      }
    }
  },
  created() {
    this.getPre()
  },
  methods: {
    // 预加载
    getPre() {
      getCoderPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.statusDict = data.statusDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.$refs.table.refresh(true)
    },
    /**
     * 打印云码
     */
    handlePrint() {
      const { relation_id, relation_type, relation_name, brand_id, is_index } = this.$route.query
      this.$router.push({ name: 'printCode', query: { relation_id, relation_type, relation_name, brand_id, is_index } })
    },
    /**
     * 导出
     */
    handleExport() {
      const { relation_id, relation_type } = this.$route.query
      // window.location.href = window.location.origin + '/merchant.php/security_code/outExcel'
      const href = window.location.origin + '/merchant.php/security_code/outExcel?relation_id=' + relation_id + '&relation_type=' + relation_type
      downloadFile(href)
    },
    // 预览图片
    handlePreviewPic(pic) {
      this.previewImage = pic
      this.previewVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
</style>
